//计算字符串中字母和数字的个数，用于兼容标题截断长度
function getByteLen(val) {
    let len = 0;
    for (let i = 0; i < val.length; i++) {
        // 全角
        if (val[i].match(/[^\x00-\xff]/ig) != null) {// eslint-disable-line
            len += 0;
        }else{
            len += 1;
        }

    }
    return len;
}

export function strEllipsis(str = '', len = 5) {
    let strLength = getByteLen(str.slice(0,len));
    return str.length > len ?  (str.slice(0,len + strLength) + '...') : str;
}


//从 AAA(dd@xx.xxx) 格式中提取出AAA
export function extractUserName(text) {
    return text == null ? '' : text.replace(/\(([a-z0-9\._-]+)@([\da-z\._-]+)\.([a-z\.]{2,7})\)/gi,'');
}

export function getScrollParent(element) {
  let scrollParent = window;

  if (element !== window) {
    while (element) {
      if (element === document.body) {
        break;
      }

      const overflowY = window.getComputedStyle(element).overflowY;
      if (overflowY === 'auto' || overflowY === 'scroll') {
        scrollParent = element;
        break;
      }
      element = element.parentElement;
    }
  }

  return scrollParent;
}

export function getScrollTop(element) {
  return (element === window) ? element.pageYOffset : element.scrollTop;
}

let topValue = 0,// 上次滚动条到顶部的距离
    interval = null,// 定时器
    scrollElement = null;

function scrollStopBack(element) {
  // 判断此刻到顶部的距离是否和1秒前的距离相等
  if(scrollElement.scrollTop == topValue) {
      clearInterval(interval);
      interval = null;
      return true;
  }
}

export function isScrollStop(element) {
  scrollElement = element;
  if(element) {
    element.onscroll = function() {
      if(interval == null) {// 未发起时，启动定时器，1秒1执行
            interval = setInterval(scrollStopBack, 500);
        topValue = element.scrollTop;
      }
    };
  }
  return true;
}
// 新增英文状态下导航按钮className
export function addEnNavClassName() {
    let enNavButtonClass = '';
    if (BSGlobal.I18NInfo && BSGlobal.I18NInfo.I18NUserLang === 'en_US') {
        enNavButtonClass = 'en-nav-button';
    }
    return enNavButtonClass;
}



// WEBPACK FOOTER //
// ./src/components/util/ui.js